import * as React from "react"
import { useRouteLoaderData, useLoaderData } from "react-router-dom"
import { Container, Row, Col } from "react-bootstrap"
import PageWrapper from "@app/components/PageWrapper"
import FormSummary from "@app/components/FormSummary"
import confirmationConfig from "@assets/confirmation-config.json"
import InspectionSyncState from "@app/components/InspectionSyncState"
import Config from "@app/constants/Config"
import { useEffect, useRef, useState } from "react"
import Button from "@app/components/Button"
import * as styles from "./archive.module.scss"
import PrintLogo from "@app/assets/images/print-logo.svg"
import classNames from "classnames"
import { formatDate } from "@app/utils/helper"

const getFirmierung = (officeId) => {
	const id = String(officeId);
	if (id.startsWith('501')) {
		return 'TRUECARE GmbH';
	}
	return 'Tempton Personaldienstleistungen GmbH';
}

export default function Archive () {
	const { inspection, inspectionConfig } = useRouteLoaderData("inspection")
	const [printMode, setPrintMode] = useState(false)
	const signatureLoader = useRef(false)

	useEffect(() => {
		const beforePrint = () => setPrintMode(true)
		const afterPrint = () => setPrintMode(false)
		window.addEventListener("beforeprint", beforePrint)
		window.addEventListener("afterprint", afterPrint)

		return () => {
			window.removeEventListener("beforeprint", beforePrint)
			window.removeEventListener("afterprint", afterPrint)
		}
	}, [])

	const checkSignature = () => {
		return new Promise((resolve) => {
			const intervalId = setInterval(() => {
				if (signatureLoader.current) {
					clearInterval(intervalId)
					resolve()
				}
			}, 100)
		})
	}

	return (
		<>
			<PageWrapper valign={"center"} className={styles.archive}>
				<InspectionSyncState />
				<Container>
					<Row>
						<Col className={classNames(styles["print-header"])}>
							<div className={classNames(styles["first-line"])}>
								<div className={"first-line-left"}>
									<img className={styles["logo"]} src={PrintLogo} alt="logo" />
									<span className={"fw-bold"}>Arbeitsplatzbesichtigung</span>
								</div>
								<div className={classNames(styles["print-header-info"], styles["first-line-right"],)}>
									<div className={styles["label"]}>Datum der Besichtigung</div>
									<div className={styles["value"]}>{inspection.visitDate ? formatDate(inspection.visitDate) : '-'}</div>
								</div>
							</div>
							<div className={classNames(styles["second-line"])}>
								<div className={styles["address"]}>
									{getFirmierung(inspection.officeId)}<br />
									{inspection.values.confirmation_office_address || '-'}
								</div>
								<div className={classNames(styles["print-header-info"])}>
									<div className={styles["label"]}>Disponent</div>
									<div className={styles["value"]}>{inspection.values.confirmation_name || '-'}</div>
								</div>
							</div>
						</Col>
					</Row>

					<Row>
						<Col>
							<FormSummary
								values={{
									...inspection.values,
								}}
								steps={[
									...inspectionConfig.forms.steps,
									inspectionConfig.forms.signsOverlayStep,
									{
										header: "Festsetzung",
										...confirmationConfig
									}
								]}
								type={inspection.type}
								basePath={`${Config.BASE_PATH}/inspection/${inspection.uuid}/`}
								mode={printMode ? "PRINT" : "ARCHIVE"}
								onSignatureLoaded={(loadState) => {
									console.log("onSignatureLoaded", loadState)
									signatureLoader.current = true
								}}
								className={styles["form-summary"]}
							/>

							{!printMode && (
								<Button
									type={"tertiary"}
									label={"PDF herunterladen"}
									className={"mt-36"}
									callback={async () => {
										await setPrintMode(true)
										await checkSignature()
										window.print()
									}}
								/>
							)}
						</Col>
					</Row>
				</Container>
			</PageWrapper>
		</>
	)
}
